import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ProposalService } from 'src/app/services/proposal/proposal.service';

@Component({
  selector: 'app-pending-overdue',
  templateUrl: './pending-overdue.component.html',
  styleUrls: ['./pending-overdue.component.scss']
})
export class PendingOverdueComponent implements OnInit {

  public data;
  overdue_contract_data: any;
  recurring_token: any;
  plan_token: any;
  refresh_counter = 0;

  constructor(
    public modalRef: BsModalRef,
    public proposal: ProposalService,
    public router: Router
  ) { }

  ngOnInit() {
    this.overdue_contract_data = this.data.planInfo;
    this.plan_token = this.data.planToken;
    this.recurring_token = this.overdue_contract_data[0].pay_recurring_token;
    this.refresh_counter = this.data.refreshCounter;
    this.proposal.getData().subscribe((data: any) => {
      if (data && data.split_request_data && data.split_request_data[0]) {
        if (data.split_request_data[0].overdue_pending_contract && data.split_request_data[0].overdue_pending_contract.length) {
          this.recurring_token = data.split_request_data[0].overdue_pending_contract[0].pay_recurring_token;
        }
      }
    });
  }

  refreshData() {
    this.refresh_counter++;
    this.router.navigate(['/plans/' + this.plan_token], { queryParams: { refresh: this.refresh_counter } });
  }

}
